import { render, staticRenderFns } from "./ResetPasswordConfirm.vue?vue&type=template&id=0837c41e&scoped=true&"
import script from "./ResetPasswordConfirm.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordConfirm.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordConfirm.vue?vue&type=style&index=0&id=0837c41e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0837c41e",
  null
  
)

export default component.exports